import Axios from 'axios';

function createBetaling(aanbod, aanvraagId, simulatieScenario) {
  let parameters = `aanvraagId=${aanvraagId}&aanbod=${aanbod}`;
  if (simulatieScenario) parameters += `&simulatieScenario=${simulatieScenario}`;

  return Axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/v1/betaling?${parameters}`).then(
    ({ data }) => data
  );
}

export default {
  createBetaling: createBetaling
};
